import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAppStore = defineStore('app', () => {
  const title = ref<string>('');
  const traceId = ref<string | null>(null);
  const version = ref<string>('');

  const setTitle = (_title: string): void => {
    title.value = _title;
    window.document.title =
      _title != '' ? 'ReCo: ' + _title : 'Recruitment Cockpit';
  };

  const setTraceId = (id: string | null) => {
    traceId.value = id;
  };

  const setVersion = (v: string) => {
    version.value = v;
  };

  return { title, setTitle, traceId, setTraceId, version, setVersion };
});
